import { data, LoaderFunctionArgs, redirect } from "react-router";
import { AuthClient } from "../internal/AuthClient";

export async function loader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);
  const hasAuthParams =
    (searchParams.has("code") || searchParams.has("error")) && searchParams.has("state");

  if (!hasAuthParams) {
    throw data("Invalid state", { status: 400 });
  }

  try {
    const { appState } = await AuthClient.handleRedirectCallback(request.url);

    let { target = "/" } = appState || {};
    const { didLogin } = appState || {};

    if (didLogin) {
      const targetUrl = new URL(appState?.target || "/", request.url);
      targetUrl.searchParams.set("didLogin", "true");
      target = targetUrl.toString();
    }

    return redirect(target);
  } catch (err) {
    const description = searchParams.get("error_description");
    if (description === "auth0.error.archived") {
      throw data("User is archived", { status: 403 });
    }
    if (description === "auth0.error.ensureUser") {
      throw data("Failed to ensureUser", { status: 500 });
    }
    if (description === "auth0.error.ensurePrincipal") {
      throw data("Failed to ensurePrincipal", { status: 500 });
    }

    throw err;
  }
}
